import { useGlobalLocale } from '@gov-nx/core/service';
import { useLocation } from 'react-router-dom';

export const useSkipToContentLink = () => {
	const { t } = useGlobalLocale();
	const location = useLocation();

	const skipToContentLinkId = 'obsah';
	const skipToContentLinkHref = `${location.pathname}#${skipToContentLinkId}`;

	return {
		skipToContentLinkId,
		skipToContentLinkHref,
		strings: {
			ariaLabelNav: t('navigace.wcag.preskoceni-na-obsah'),
			ariaLabelLink: t('odkaz.preskocit-na-obsah'),
			text: t('odkaz.preskocit-na-obsah'),
		},
	};
};
